/// <amd-module name="Feed/Legacy/Components/ViewsGridCell" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";

import { TooltipHost, TooltipOverflowMode } from "VSSUI/Tooltip";

import { FeedView, FeedViewType, MinimalPackageVersion } from "Feed/Common/Contracts/Feed";

export interface IViewsGridCellProps {
    packageVersion: MinimalPackageVersion;
}

export const ViewsGridCell: React.StatelessComponent<IViewsGridCellProps> = (
    props: IViewsGridCellProps
): JSX.Element => {
    const filteredViews = props.packageVersion.views
        .filter((v: FeedView) => v.type !== FeedViewType.Implicit)
        .sort((a: FeedView, b: FeedView) => Utils_String.localeComparer(a.name, b.name));
    const viewsString: string = filteredViews
        .map((view: FeedView) => {
            return "@" + view.name;
        })
        .join(", ");

    return (
        // TODO: +1 instead of tooltip
        <div className="views-grid-cell">
            <TooltipHost content={viewsString} overflowMode={TooltipOverflowMode.Parent}>
                <ul className="release-views">
                    {filteredViews.map((view: FeedView) => {
                        return (
                            <li className="view-bubble" key={view.id}>
                                {"@" + view.name}
                            </li>
                        );
                    })}
                </ul>
            </TooltipHost>
        </div>
    );
};
